import React, { Component } from "react";
import ShareIcon from "@material-ui/icons/Share";

export default class ProductShare extends Component {
  render() {
    return (
      <div
        onClick={() => this.props.share()}
        className="w-100 text-center mt-5 py-3"
        style={{
          userSelect: "none",
          cursor: "pointer",
          borderTopStyle: "solid",
          borderTopWidth: 1,
          borderTopColor: "#dbdbdb",
          borderBottomStyle: "solid",
          borderBottomWidth: 1,
          borderBottomColor: "#dbdbdb"
        }}
      >
        <p style={{ color: "#969696" }}>
          <span>
            <ShareIcon style={{ color: "#bababa", marginRight: 10 }} />
          </span>{" "}
          SHARE WITH A FRIEND
        </p>
      </div>
    );
  }
}
